/* eslint-disable valid-typeof */
function helperCreateInTypeof (type) {
  return function (obj) {
    return typeof obj === type
  }
}

module.exports = helperCreateInTypeof



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperCreateInTypeof.js
// module id = YPUl
// module chunks = 137